// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"contacts_wrapper__YfD2X","contacts":"contacts_contacts__znaDO","card":"contacts_card__aNnpL","text":"contacts_text__PkduF","address":"contacts_address__plcKQ"};